import io from 'socket.io-client'

const socket = io('https://dpmptsp.bekasikota.go.id', {
    path: '/socket.io',
    transports: ['websocket'],
    withCredentials: true,
    autoConnect: true,
    secure: true
})

export default socket